import Vue from 'vue'
import Vuex from 'vuex'
import axios from './axios-auth'
import router from '../router/index.js'
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // Existing state
    accessToken: null,
    userData: [],
    progressItems: [],
    lastCheckedProgress: null,
    loggingIn: false,
    transactionItems: [],
    latestPrescription:[],
    appointments: null,
    lab: null,
    priscription: null,
    shipping: null,
    tracking: null,
    ipAddress: null,
    medForm: null,
    prescriptionPreauths: null,
    lastCheckedSubscription: null,
    subscriptionItems:[],
    lastCheckedTransactions: null,
    trackingData: [], 
    // Cart state
    cartItems: [],
    isCartOpen: false,
    weightLossOffer: null,
    // New product-related state
    currentCategory: 'WEIGHT LOSS',
    loading: false,
    error: null,
    offerSema: 'sema_plan_278928',
    offerTir: 'tirz_plan_1',
    chatProfile:null,
    case: {id: "" , provider: ""},
    doctorProfile:[],
    encounter: null,
    docChat: false,
    activeHomeTab: 'myNewSelf',
  },
  
  mutations: {
    SET_SEMA_OFFER(state, offer) {
      const offerSemaMap = {
        A: 'sema_plan_134562',
        C: 'sema_plan_367367',
      };
    
      // Assign based on offer, defaulting to 'sema_plan_278928'
      state.offerSema = offerSemaMap[offer] || 'sema_plan_278928';
    },
    SET_ENCOUNTER_ID(state, order) {
      state.encounter = order
    },
    SET_TIR_OFFER(state, offer) {
      const offerTirMap = {
        C: 'tirz_plan_3',
        B: 'tirz_plan_2',
      };
      // Assign based on offer, defaulting to 'tirz_plan_1'
      state.offerTir = offerTirMap[offer] || 'tirz_plan_1';
    },
    SET_ACTIVE_HOME_TAB(state, tab) {
        state.activeHomeTab = tab;
    },
    SET_Transactions_ITEMS(state, payload) {
      
      if (payload && payload.items) {
        state.transactionItems = payload.items;
        state.lastCheckedTransactions = payload.timestamp;
      }
    },
    SET_SUBSCRIPTION_ITEMS(state, payload) {
      
      if (payload && payload.items) {
        state.subscriptionItems = payload.items;
        state.lastCheckedSubscription = payload.timestamp;
      }
    },
    SET_PROGRESS_ITEMS(state, payload) {
      
      if (payload && payload.items) {
        state.progressItems = payload.items;
        state.lastCheckedProgress = payload.timestamp;
      }
    },
    SET_PRESCRIPTION_PREAUTHS(state, preauths) {
      state.priscription = preauths;
    },
    SET_HEALTH_ID(state, payload) {
      if (payload && payload.health_id &&(!state.userData.health_id || state.userData.health_id === '')){
        state.userData.health_id = payload.health_id;
      }
    },
    REMOVE_PRESCRIPTION(state, orderId) {
      state.priscription = state.priscription.filter(
        preauth => preauth.orderId !== orderId
      );
    },
    // Existing mutations remain the same
    loginStart: state => state.loggingIn = true,
    updateAccessToken: (state, accessToken) => {
      state.accessToken = accessToken;
    },
    updateUserData: (state, userData) => {
      state.userData = { ...state.userData, ...userData }
    },
    logout: (state) => {
      state.accessToken = null;
      localStorage.removeItem('accessToken');
      localStorage.removeItem('user');
    },
    
    SaveShippingDetails: (state, shipping) => {
      state.shipping = shipping
    },
    setIpAddress(state, ipAddress) {
      state.ipAddress = ipAddress;
    },
    
    // Cart mutations
    ADD_TO_CART(state, item) {
      console.log('Cart item being added to cart in store:', item); // Debug log
      const existingItem = state.cartItems.find(i => i.id === item.id);
      
      // Create the new item with all properties explicitly
      const newItem = {
          id: item.id,
          name: item.name,
          price: item.price,
          retail_price: item.retail_price,
          quantity: item.quantity,
          main_type: item.main_type,
          subheader: item.subheader,
          image: item.image,
          category: item.category,
          sku: item.sku,
          stripe_id: item.stripe_id
      };
      console.log(newItem)
      if (existingItem) {
        existingItem.quantity += 1;
      } else {
          state.cartItems.push(newItem);
      }
      /*if (item.main_type === "prescription") {
          if (!existingItem) {
              state.cartItems.push(newItem);
          }
      } else {
          if (existingItem) {
              existingItem.quantity += 1;
          } else {
              state.cartItems.push(newItem);
          }
      }*/
  },
    
    REMOVE_FROM_CART(state, itemId) {
      state.cartItems = state.cartItems.filter(item => item.id !== itemId);
    },
    
    UPDATE_CART_QUANTITY(state, { itemId, quantity }) {
      const item = state.cartItems.find(i => i.id === itemId);
      if (item) {
        if (item.main_type === "Prescription") {
          item.quantity = 1;
        } else {
          if (quantity > 0) {
            item.quantity = quantity;
          } else {
            state.cartItems = state.cartItems.filter(i => i.id !== itemId);
          }
        }
      }
    },
    
    CLEAR_CART(state) {
      state.cartItems = [];
    },
    
    SET_CART_VISIBILITY(state, isVisible) {
      state.isCartOpen = isVisible;
    },

    // New product-related mutations
    SET_CURRENT_CATEGORY(state, category) {
      state.currentCategory = category;
    },
    SET_DOC_CHAT(state) {
      state.docChat = !state.docChat;
    },
    SET_LOADING(state, status) {
      state.loading = status;
    },
    
    SET_ERROR(state, error) {
      state.error = error;
    },
    SET_CHAT_PROFILE(state, profile) {
      state.chatProfile = profile;
    },
    SET_NEW_PHONE(state, phone) {
      state.userData.phone = phone;
    },
    SET_NEW_EMAIL(state, email) {
      state.userData.email = email;
    },
    SET_PRESCRIPTION(state, prescription) {
      state.latestPrescription = prescription;
    },
    SET_CASE_ID(state, order) {
      state.case = order
    },
    SET_DOC_PROFILE(state, doctorProfile) {
      state.doctorProfile = doctorProfile
    },
      
  },

  actions: {
      setChatProfile({ commit }, profileData) {
        try {
            // Validate required fields
            if (!profileData || !profileData.email || !profileData.first_name) {
                throw new Error('Invalid chat profile data');
            }

            // Store in localStorage for persistence
            localStorage.setItem('chatProfile', JSON.stringify(profileData));
            commit('SET_CHAT_PROFILE', profileData);
            
            return Promise.resolve(profileData);
        } catch (error) {
            console.error('Error setting chat profile:', error);
            return Promise.reject(error);
        }
    },
    updateUserPhone({ commit }, phone) {
      commit('SET_NEW_PHONE', phone);
    },
    updateUserEmail({ commit }, email) {
      commit('SET_NEW_EMAIL', email);
    },
    
    addSemaOffer({ commit }, offer) {
      commit('SET_SEMA_OFFER', offer);
    },
    addTirOffer({ commit }, offer) {
      console.log("setting offer")
      commit('SET_TIR_OFFER', offer);
    },
    updateTransactionItems({ commit }, payload) {
      commit('SET_Transactions_ITEMS', payload);
    },
    updateSubscriptions({ commit }, payload) {
      commit('SET_SUBSCRIPTION_ITEMS', payload);
    },
    updateProgress({ commit }, payload) {
      commit('SET_PROGRESS_ITEMS', payload);
    },
    setPrescriptionPreauths({ commit }, preauths) {
      commit('SET_PRESCRIPTION_PREAUTHS', preauths);
    },
    UpdateUserData({ commit }, userData) {
      commit('updateUserData', userData)
      return Promise.resolve() // Return a promise for proper async handling
    },
    removePrescription({ commit }, orderId) {
      commit('REMOVE_PRESCRIPTION', orderId);
    },
    // Existing actions remain the same
    saveTransaction({ commit }, data) {
      commit('SaveTransactions', data);
    },
    saveShippingDetails({ commit }, data) {
      commit('SaveShippingDetails', data);
    },
    doLogin({ commit }, loginData) {
      commit('updateAccessToken', loginData.token.token);
      commit('updateUserData', loginData.user);
    },
    
    logout({ commit }, data) {
      return new Promise((resolve, reject) => {
        let token = data.token;
        axios.get("/logout", {
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
          }
        }).then(res => {
          commit('updateAccessToken', null);
          console.log(res);
          localStorage.removeItem('_ymain_key_');
          router.push({ name: 'LoginPage' });
        }).catch(error => {
          reject(error)
        });
      });
    },
    setActiveHomeTab({ commit }, tab) {
        commit('SET_ACTIVE_HOME_TAB', tab);
    },
    async getIpAddress({ commit }) {
      try {
        const response = await axios.get('https://api.ipify.org/?format=text');
        commit('setIpAddress', response.data);
      } catch (error) {
        console.error('Error fetching IP address:', error);
      }
    },

    // Cart actions
    addToCart({ commit }, item) {
      
      commit('ADD_TO_CART', item);
      commit('SET_CART_VISIBILITY', true);
    },
    
    removeFromCart({ commit }, itemId) {
      commit('REMOVE_FROM_CART', itemId);
    },
    
    updateCartQuantity({ commit }, { itemId, quantity }) {
      commit('UPDATE_CART_QUANTITY', { itemId, quantity });
    },
    
    clearCart({ commit }) {
      commit('CLEAR_CART');
    },
    
    setCartVisibility({ commit }, isVisible) {
      commit('SET_CART_VISIBILITY', isVisible);
    },

    // New product-related actions
    setCategory({ commit }, category) {
      commit('SET_CURRENT_CATEGORY', category);
    },
    
    setLoading({ commit }, status) {
      commit('SET_LOADING', status);
    },
    updateHealth({ commit }, payload) {
      commit('SET_HEALTH_ID', payload);
    },
    setError({ commit }, error) {
      commit('SET_ERROR', error);
    },
    setPrescription({ commit }, prescription) {
      commit('SET_PRESCRIPTION', prescription);
    },
    setCaseID({ commit }, order) {
      commit('SET_CASE_ID', order);
    },
    toggeleDocChat({ commit }) {
      console.log("turning on doc")
      commit('SET_DOC_CHAT');
    },
    setEncounterId({ commit }, order) {
      commit('SET_ENCOUNTER_ID', order);
    },
    setDocProfile({ commit }, docProfile) {
      commit('SET_DOC_PROFILE', docProfile);
    },
  },

  getters: {
    offerSema: state => state.offerSema,
    offerTir: state => state.offerTir,
    lastCheckedProgress: state => state.lastCheckedProgress,
    progressItems: state => state.progressItems,
    user: state => state.userData,
    isAuthenticated: state => state.accessToken !== null,
    docChatStatus: state => state.docChat,
    isAdmin: state => state.userData?.is_admin === 1,
    authToken: state => state.accessToken,
    transactionItems: state => state.transactionItems,
    lastCheckedTransactions: state => state.lastCheckedTransactions,
    activeHomeTab: state => state.activeHomeTab,
    subscription: state => state.subscription,
    appointment: state => state.appointments,
    prescription: state => state.priscription,
    tracking: state => state.tracking,
    lab: state => state.lab,
    shipping: state => state.shipping,
    medForm: state => state.medForm,
    ipAddress: state => state.ipAddress,
    chatProfile: state => state.chatProfile,
    hasChatProfile: state => state.chatProfile!=null,
    getLatestPrescription: state => {
      // If progressItems is empty or not an array, return empty array
      if (!state.progressItems || !Array.isArray(state.progressItems) || state.progressItems.length === 0) {
        return [];
      }

      // Collect all prescriptions across all orders
      const allPrescriptions = state.progressItems
        .filter(order => order.prescription_data && Array.isArray(order.prescription_data))
        .flatMap(order => order.prescription_data);
      
      // If we found no prescriptions, return empty array
      if (allPrescriptions.length === 0) {
        return [];
      }
      
      return allPrescriptions;
    },
    // Cart getters
    cartItems: state => state.cartItems,
    cartItemCount: state => state.cartItems.reduce((total, item) => total + item.quantity, 0),
    cartTotal: state => {
      return state.cartItems.reduce((total, item) => {
        const price = parseFloat(item.price.toString());
        return total + (price * item.quantity);
      }, 0);
    },
    cartTotalNoDiscount: state => {
      return state.cartItems.reduce((total, item) => {
        const price = parseFloat(item.retail_price.toString());
        return total + (price * item.quantity);
      }, 0);
    },

    cartDiscount: state => {
      console.log(JSON.stringify(state.cartItems))
      return state.cartItems.reduce((total, item) => {
        const retailPrice = parseFloat(item.retail_price.toString().replace('$', ''));
        const currentPrice = parseFloat(item.price.toString().replace('$', ''));
        return total + ((retailPrice - currentPrice) * item.quantity);
      }, 0);
    },
    isCartOpen: state => state.isCartOpen,
    getRemainingPrescriptions: state => state.priscription,
    // New product-related getters
    currentCategory: state => state.currentCategory,
    loading: state => state.loading,
    error: state => state.error,
    lastCheckedSubscription: state => state.lastCheckedSubscription,
    subscriptionItems: state => state.subscriptionItems,
    getLatestEncounter : state => state.encounter,
    getCase: state => {
      // If progressItems is empty or not an array, return null
      if (!state.progressItems || !Array.isArray(state.progressItems) || state.progressItems.length === 0) {
        return null;
      }
      
      // First try to find orders with external_visit_id (any provider)
      const ordersWithExternalVisitId = state.progressItems.filter(order => order.external_visit_id);
      
      if (ordersWithExternalVisitId.length > 0) {
        // Return the first order with external_visit_id
        return {
          id: ordersWithExternalVisitId[0].external_visit_id,  
          provider: ordersWithExternalVisitId[0].provider
        };
      }
      
      // Fallback: look for any provider 3 order (even without external_visit_id)
      const provider3Orders = state.progressItems.filter(order => order.provider === 3);
      if (provider3Orders.length > 0) {
        return {
          id: provider3Orders[0].id,
          provider: provider3Orders[0].provider
        };
      }
      
      return null;
    },
    docProfile: state => state.doctorProfile,
    // Add this new getter to get all orders with prescriptions
    getOrdersWithPrescriptions: state => {
      if (!state.progressItems || !Array.isArray(state.progressItems)) {
        return [];
      }
      
      return state.progressItems.filter(order => 
        order.prescription_data && 
        Array.isArray(order.prescription_data) && 
        order.prescription_data.length > 0
      );
    }
  },

  plugins: [
    createPersistedState({
      key: '_ymain_key_',
      paths: [
        'accessToken', 
        'userData', 
        'transaction', 
        'subscription', 
        'appointments', 
        'lab', 
        'priscription', 
        'shipping', 
        'tracking',
        'ipAddress',
        'medForm',
        'cartItems',
        'isCartOpen',
        'currentCategory',
        'progressItems', 
        'lastCheckedProgress',
        'subscriptionItems',
        'lastCheckedSubscription',
        'transactionItems',
        'lastCheckedTransactions',
        'offerTir',
        'offerSema',
        'trackingData',
        'chatProfile',
        'latestPrescription',
        'case',
        'doctorProfile',
        'encounter',
        'activeHomeTab'
      ]
    })
  ],
})
